<template>
    <view-validation-plan-template-component :assesmentMethods="assesmentMethods" :currentValidationPlanTemplate="currentValidationPlanTemplate" :validationParameters="validationParameters" @back="handleBack" @editValidationPlanTemplate="handleEditValidationPlanTemplate"></view-validation-plan-template-component>
</template>

<script>
import ViewValidationPlanTemplateComponent from '@/components/template/ViewValidationPlanTemplateComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'
import MetadataParser from "@/valchrom/MetadataParser";

export default {
    name: 'ViewValidationPlanTemplate',
    components: {ViewValidationPlanTemplateComponent},
    data: function () {
        return {
            component_url: 'experiments/templates/',
            currentValidationPlanTemplate: {},
            assesmentMethods:[],
        }
    },

    computed: {
        ...mapGetters ([
            'base_url', 'currentValidationPlanTemplateID', 'auth_header', 'validationParameters'
        ]),        
        
    },
    
    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_VALIDATION_PLAN_TEMPLATE_ID'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        setValidationPlanTemplateId: function(){
            this.CHANGE_VALIDATION_PLAN_TEMPLATE_ID(this.currentValidationPlanTemplate.id)
        },
        getValidationPlanTemplate: function(){ 
            axios
                .get(
                    this.base_url+this.component_url+this.currentValidationPlanTemplate.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    MetadataParser.getMetadatasFromJsons(response.data)
                    this.currentValidationPlanTemplate = response.data;
                    this.currentValidationPlanTemplate.assessment_methods_objects = []

                    var mainThis = this
                    response.data.ams.forEach(function(method, i, array) {
                        mainThis.handleAMData(method)
                    })
                    
                    console.log("this.currentValidationPlanTemplate", this.currentValidationPlanTemplate)
                    
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ValidationPlanTemplate", error);
                });
                
        },
        getAssesmentMethod: function(method, currentValidationPlanTemplate){

            axios
                .get(
                    this.base_url+ "experiments/assessments/"  +
                    method,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    var meth = response.data
                    this.handleAMData(meth);
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ass meth", error);
                });
        },
        handleAMData(meth){
            meth.criteria =[]
            // loop criteria and add to the method
            this.currentValidationPlanTemplate.criteria.forEach(function(item, index, array) {
                if(item.assessment_method==meth.code_name){
                    meth.criteria.push(item)
                }
            })
            // Add am to the array
            this.currentValidationPlanTemplate.assessment_methods_objects.push(meth)
            this.assesmentMethods.push(meth)
        },
        handleEditValidationPlanTemplate: function(currentValidationPlanTemplate) {
            console.log("handleEditValidationPlanTemplate: currValidationPlanTemplate is ", currentValidationPlanTemplate.name)
            this.$router.push({ name: "EditValidationPlanTemplate", params: { id: currentValidationPlanTemplate.id } });
        },
        handleBack: function() {
            console.log("handleBack function...")
            this.$router.push({ name: "ValidationPlanTemplates", params: {} });
        }        
    },

    mounted: function() {
        this.setBreadcrumb()

        if (this.$route.params.id) {
            this.currentValidationPlanTemplate.id = this.$route.params.id;
        }
        else {
            console.log("OpenValidationPlanTemplate view no router params.id")
            this.currentValidationPlanTemplate.id = this.currentValidationPlanTemplateID;
        }        
        
        this.getValidationPlanTemplate();
        this.setValidationPlanTemplateId();
    }
}
</script>

